import React, { useState, useEffect } from "react"
import dayjs from 'dayjs';
import { getApiFeedData } from "./utils"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import SectionHeaderRender from "lib/units/element/SectionHeader/SectionHeaderRender"

export default function NotesRender({ renderPkg }:{ renderPkg?:any }){
  
  const [ notesToDisplay, setNotesToDisplay ] = useState<any>([])

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "notes")?.settings || null

  const firstPStyle = useRenderStyling("block mb-0 leading-tight", "styleObj")
  const outerStyling = useRenderStyling("mm-section w-full flex flex-col pl-0 mb-4", "styleObj")
  const innerStyling = useRenderStyling("w-full mt-4 pl-4 pr-6", "styleObj")
  const wrapperStyling = useRenderStyling("w-full flex flex-col border border-solid border-neutral-700 text-sm p-4", "styleObj")
  const contentStyling = useRenderStyling("w-full mt-1 mb-1", "styleObj")
  const noteDateStyling = useRenderStyling("", "styleObj")
  const noteContentStyling = useRenderStyling("", "styleObj")

  const parseProps = { clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata} 

  const prepNotes = () => {
    const notes = getApiFeedData(renderPkg.clientdata, "rp.RepresentmentTransactionInfo.Notes")
    console.log("notes", notes)
    setNotesToDisplay(notes.filter((note:any) => note.IncludeInLetter === true))
  }


  // return {
  //       wasCsContacted: apiData.rp.RepresentmentTransactionInfo.WasCustomerServiceContacted,
  //       lastContactDate: apiData.rp.RepresentmentTransactionInfo.LastCustomerServiceContactDate,
  //       lastContactReason: apiData.rp.RepresentmentTransactionInfo.LastCustomerServiceContactReason,
  //       notes: apiData.rp.RepresentmentTransactionInfo.Notes.filter((note:any) => note.IncludeInLetter === true) || []
  //     }

  useEffect(() => {
    prepNotes()
  },[])

  if( !notesToDisplay.length ) return <></>
  return (
    <div id="mm-notes" {...outerStyling}>

      <SectionHeaderRender title="Customer Service Notes" />

      <div {...innerStyling}>
        <div {...wrapperStyling}>
          { notesToDisplay.map( (note:any, idx:number) => (
            <div key={idx} {...contentStyling}>
              <span {...noteDateStyling}>{dayjs(note.Timestamp).format("MM/DD/YYYY")} - </span>
              <span {...noteContentStyling}>{note.Note}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}